// extracted by mini-css-extract-plugin
export var equalColumn = "_e6-0";